import { compose, mdsWidget } from 'dojo/_base/declare';
import { DistributionCHannelKanbanDataElement, HtEvBookingEvDistributionChannel, TableColumn, TableContainer, TableRow, VtFinance } from "./DistributionChannelKanbanTypes";
import lang from 'dojo/_base/lang';
import { EntityHelpers, FeatureHelpers } from "../../../more/Helpers";
import _EntityViewMixin from '../../../moreCore/UI/EntityBased/EntityView/EntityView';
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import BudgetTable from '../../CostCalculation/BudgetTable';

class DistributionChannelKanbanView extends compose(GenericEntityView) {

    setup(distributionAssignmentID: any, label?: any) {
        this.setContextName("DistributionChannelKanban");
        debugger;
        this.showAsDlg(distributionAssignmentID, label);

    }

    onShow() {
        // zb weitere Buttons zum Dlg oder in den Tab einfügen...

    }

    onViewContentSet() {

    }

    public onDataLoaded() {
        let bBudgetAvailable = FeatureHelpers.hasFeature("Planning/BudgetCalculationRoster");        

        if (bBudgetAvailable == true) {
            this.addButton("budgetCalculation", "BudgetCalculationRoster_MainTitle", lang.hitch(this, this._loadBudgetCalculation), null, "primary", "fas fa-euro-sign", false, "last", true);
        } else {
            this.removeButton("budgetCalculation");
        }
    }

    private _loadBudgetCalculation() {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_BudgetCalculation__GetMainConfig",
            {
                htDistributionChannelID: this.entityID
            },
            lang.hitch(this, this._openBudgetCalculation, true),
            lang.hitch(this, this._openBudgetCalculation, false)
        );
    }

    private _openBudgetCalculation(success: boolean, response) {
        this.StandbyStop();

        if (success) {
            let calc = new BudgetTable();
            calc.setup(response, "fullScreenDlg", this.title);
        } else {
            this.showToast({
                title: "error loading budget configuration",
                iconClass: toasterIcons.error,
                message: response
            });
        }

    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.config.entityClassname = "ht_evbooking_evdistribution";
        this.config.labelProperty = "gDisp_1";
        this.config.entityClassPrintname = "ht_evbooking_evdistribution"

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DistributionChannelKanbanView);
